// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3HjpO","list":"BalanceDue_list__1PCJk","listRow":"BalanceDue_listRow__2zVJ7","total":"BalanceDue_total__3LJrn"};